export function timeUtils (time) {
    let year = time.getFullYear() //返回指定日期的年份
    let month = repair(time.getMonth() + 1);//月
    let day = repair(time.getDate());//日
    return year + '-' + month + '-' + day
}

function repair(i){
    if (i >= 0 && i <= 9) {
        return "0" + i;
    } else {
        return i;
    }
}